var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.modalTitle)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "form",
                    {
                      attrs: { id: "discrete-scale-editor-form" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.handleFormSubmit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Name:")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.name,
                              expression: "name",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            required: "",
                            minlength: "2",
                            maxlength: "100",
                          },
                          domProps: { value: _vm.name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.name = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "error" }, [
                          _vm._v(_vm._s(_vm.nameError)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Description:")]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.description,
                              expression: "description",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { rows: "3" },
                          domProps: { value: _vm.description },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.description = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "error" }, [
                          _vm._v(_vm._s(_vm.descriptionError)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _vm._l(_vm.levels, function (l) {
                        return _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { "margin-bottom": "5px" },
                            },
                            [
                              _c("div", { staticClass: "col-sm-3" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: l.Name,
                                      expression: "l.Name",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Level",
                                    required: "",
                                    minlength: "2",
                                    maxlength: "100",
                                  },
                                  domProps: { value: l.Name },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        l,
                                        "Name",
                                        $event.target.value.trim()
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "error" }, [
                                  _vm._v(_vm._s(l.NameError)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-2" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: l.Value,
                                      expression: "l.Value",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    placeholder: "Number...",
                                    required: "",
                                  },
                                  domProps: { value: l.Value },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        l,
                                        "Value",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "error" }, [
                                  _vm._v(_vm._s(l.ValueError)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-6" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: l.Definition,
                                      expression: "l.Definition",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    rows: "1",
                                    placeholder: "Definition for level",
                                  },
                                  domProps: { value: l.Definition },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        l,
                                        "Definition",
                                        $event.target.value.trim()
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-1" }, [
                                _c("a", {
                                  staticClass: "pointer fa fa-times",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeScaleLevel(l)
                                    },
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ])
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.levelsError)),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "text-primary",
                            on: { click: _vm.addScaleLevel },
                          },
                          [_vm._v("Add scale level")]
                        ),
                      ]),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-footer justify-content-between" },
                  [
                    _c("div", { staticClass: "dropdown dropup" }, [
                      _vm.canDelete
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Delete\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          staticStyle: { padding: "10px" },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: { click: _vm.handleDeleteScale },
                            },
                            [_vm._v("Confirm")]
                          ),
                          _vm._v(" "),
                          _c("a", { staticClass: "dropdown-item" }, [
                            _vm._v("Cancel"),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "submit",
                            form: "discrete-scale-editor-form",
                          },
                        },
                        [_vm._v(_vm._s(_vm.confirmButtonLabel))]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "row", staticStyle: { "margin-bottom": "5px" } },
      [
        _c("div", { staticClass: "col-sm-3" }, [
          _c("label", [
            _vm._v("Scale level "),
            _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-2" }, [
          _c("label", [
            _vm._v("Value "),
            _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c("label", [_vm._v("Definition")]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }